@if (
  loadingService.States[
  loadingService.getIdFromArrayStateByType(
  loadingService.StatesNames.GLOBAL
  )
  ].value) {
  <app-preloader
  ></app-preloader>
} @else {
  <router-outlet></router-outlet>
}




